import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useInquiry } from './InquiryProvider';

import { Button } from '@/components/atoms/PcButton';

import InquiryContent from './InquiryContent';
import EmptyFaceIcon from '@/assets/icons/EmptyFaceIcon.svg?react';

import { LayoutReviewsBody } from '../../_layouts/LayoutsReviewsBody';

import type { InquiryItem } from '@/types/api';
import NotRegisteredState from '../common/NotRegisteredState';

interface InquiryBodyProps {
  inquries: InquiryItem[];
}

const InquiryBody = ({ inquries }: InquiryBodyProps) => {
  const { currentTab, marketList } = useInquiry();
  const navigate = useNavigate();

  // 1. 연동된 마켓이 없는 경우
  // if (!marketList || marketList.length === 0) {
  if (!marketList || marketList.length === 0) {
    return <NotRegisteredState className="bg-white" />;
  }

  // 2. 문의가 없는 경우
  if (!inquries.length) {
    let emptyText = '문의가 없습니다';
    if (currentTab === 'not-yet') {
      emptyText = '처리할 문의가 없어요';
    } else if (currentTab === 'completed') {
      emptyText = '처리한 문의가 없어요';
    }
    return (
      <div className="flex h-full w-full flex-col items-center justify-center gap-[20px]">
        <EmptyFaceIcon />
        <div className="text-gr-700 Body1S16">{emptyText}</div>
      </div>
    );
  }

  return (
    <LayoutReviewsBody>
      {inquries.map((inquiry) => (
        <InquiryContent inquiry={inquiry} key={inquiry.InquiryNo} />
      ))}
    </LayoutReviewsBody>
  );
};

export default InquiryBody;
